<template>
  <component :is="component" v-if="component" :competitionData="competitionData" />
</template>

<script>
export default {
  name: "CompetitionDetailLink",
  mixins: [],
  components: {
  },
  inject: [],
  provide() {
    return{

    }
  },
  props: {
    detailLayout: '',
      competitionData: {default: () => {}},
  },
  data() {
    return{
      component: null,
    }
  },
  beforeRouterEnter() {},
  created() {
  },
  mounted() {
    this.loader()
        .then(() => {
          this.component = () => this.loader()
        })
        .catch(() => {
          this.component = () => import('@/template/competition/detail/CompetitionDetailDefaultLayout')
        })
  },
  beforeDestroy() {
  },
  destroyed() {},
  computed: {
    loader() {
      if (!this.detailLayout) {
        return null
      }
      return () => import(`@/template/competition/detail/${this.detailLayout}`)
    },
  },
  methods:{

  },
  watch: {

  },
}
</script>

<style scoped>

</style>
